import { ReactNode } from "react";
import {
  styled,
  Accordion,
  AccordionDetails,
  AccordionSummary,
  AccordionProps,
} from "@mui/material";
import { ArrowDropDown } from "@mui/icons-material";

interface Props extends Omit<AccordionProps, "title" | "children"> {
  title: ReactNode;
  children: ReactNode;
}

export function PointAccordion(props: Props) {
  const { title, children, ...accordionProps } = props;
  return (
    <Styles elevation={0} {...accordionProps}>
      <AccordionSummary expandIcon={<ArrowDropDown />}>
        {title}
      </AccordionSummary>
      <AccordionDetails>{children}</AccordionDetails>
    </Styles>
  );
}

const Styles = styled(Accordion)`
  background: unset;

  .MuiAccordionSummary-root {
    flex-direction: row-reverse;
    background-color: unset;
    font-weight: bold;

    &.Mui-expanded {
      min-height: unset;
    }
    .MuiAccordionSummary-content {
      & > .MuiCircularProgress-root {
        transform: translateY(${({ theme }) => theme.spacing(3)});
        margin-left: ${({ theme }) => theme.spacing(1)};
      }
      &.Mui-expanded {
        margin: ${({ theme }) => theme.spacing(1.5, 0)};
      }
    }

    .MuiAccordionSummary-expandIconWrapper {
      &:not(.Mui-expanded) {
        transform: rotate(-90deg);
      }
      &.Mui-expanded {
        transform: rotate(0deg);
      }
    }
  }
`;
